module.exports = __webpack_public_path__ + "images/emoji/mailbox_with_no_mail.2f523f2179bea7c30ab1.png";